<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="Form"
          :model="DeviceData"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <div class="terminal-transfer">
            <el-form-item>
              <!-- <el-transfer v-model="toData" :data="fromData"></el-transfer> -->
              <tree-transfer
                :title="title"
                :from_data="fromData"
                :to_data="toData"
                :defaultProps="{ label: 'label' }"
                @addBtn="add"
                @removeBtn="remove"
                :mode="mode"
                :pid="parent_id"
                height="400px"
                filter
                openAll
                :filterNode="filterNode"
              >
              </tree-transfer>
            </el-form-item>
          </div>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button @click="preStep">上一步</el-button>
        <el-button type="primary" @click="OnConfirm('Form')">保存</el-button>
        <!-- <el-button @click="nextStep">下一步</el-button> -->
        <el-button @click="onBack">返回</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import treeTransfer from "el-tree-transfer"; // 引入
import utils from "../../../../../../utils";
import { listEquipmentArea,listEquipmentAreaTree } from "@/api/src/equipmentArea";
import { listEquipment } from "@/api/src/equipment";
import { broadcastOrderBatchUpdate,broadcastOrderEquipmentList } from "@/api/src/broadcast";

export default {
  name: "TerminalConfig",
  props: {
    // TaskDeviceList: {
    //   type: Array,
    // },
    taskId: {
      type: String,
    },
  },
  components: { treeTransfer }, // 注册
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      rules: {
        FinishDesc: [
          { required: true, message: "请输入结案说明", trigger: "blur" },
        ],
      },
      parent_id:'pid',
      title: ["备选终端", "确认终端"], //标题 类型：Array 必填：false 默认：["源列表", "目标列表"]
      mode: "transfer", //设置模式，字段可选值为transfer|addressList 类型：String 必填：false 补充：mode默认为transfer模式，即树形穿梭框模式，可配置字段为addressList改为通讯录模式，通讯录模式时按钮不可自定义名字，如要自定义标题名在title数组传入四个值即可，addressList模式时标题默认为通讯录、收件人、抄送人、密送人
      fromData: [], //源数据 类型：Array 必填：true 补充：数据格式同element-ui tree组件，但必须有id和pid
      toData: [], //目标数据 类型：Array 必填：true 补充：数据格式同element-ui tree组件，但必须有id和pid
      regions: [],
      DeviceData: { toData: [] },
      confirmDataList: [],
      DeviceList: [],
      TaskDeviceList:[]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.loadingText = "加载中...";
      //  this.SelectedSys = {};
      const that = this;
      // () => listEquipmentArea({pageNum:1,PageSize:9999}),
      return utils
        .waitAll([() => this.getEquipments(),()=>this.getBangEquipmentList()])
        .then((r) => {
          console.log("r")
          console.log(r)
          let deviceArr = r[0].rows;
          that.TaskDeviceList = r[1].data;
          deviceArr.map(deviceItem => {
            deviceItem.pid = 'area';
            deviceItem.label = deviceItem.equipmentName;
            deviceItem.type = 'Device';
          })
          if (that.TaskDeviceList.length > 0) {
            let map = {};
            let fromResults = [];  //存放备选数据
            let results = [];  //存放确认数据
            that.TaskDeviceList.forEach((element) => {
              element.pid='area';
              map[element.id] = element;
            });
            deviceArr.forEach((item) => {
              if (map[item.id]) {
                results.push(item);
              } else {
                fromResults.push(item);
              }
            });
            that.fromData = that.addAllToTree(fromResults);
            that.toData = that.addAllToTree(results);
          } else {
            that.fromData = that.addAllToTree(deviceArr);
          }
          that.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          // console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 扁平数组转树形结构
    arrayToTree(arr, id) {
      const temp = [];
      for (const item of arr) {
        if (item.pid == id) {
          temp.push({...item, children: this.arrayToTree(arr, item.id)});
        }
      }
      return temp;
    },
    addAllToTree(data){
      return [
        {
          id: 'area',
          label: "全部设备",
          pid: "pid",
          type: "all",
          children: this.arrayToTree(data, 'area')
        },
      ];
    },
    //获取设备列表
    getEquipments() {
      // return new MyApis.TranResourcesApi().GetEquipmentMangeList({
      //   EquipmentType: "Broadcast",
      // });
      return listEquipment({
        PageSize: 9999,
        pageNum: 1,
        categoryCode:"broadcast"
      })
    },
    getBangEquipmentList(){
      return broadcastOrderEquipmentList({
        orderId:this.taskId,
        pageNum:1,
        pageSize:9999
      })
    },
    // 切换模式 现有树形穿梭框模式transfer 和通讯录模式addressList
    changeMode() {
      if (this.mode == "transfer") {
        this.mode = "addressList";
      } else {
        this.mode = "transfer";
      }
    },
    // 监听穿梭框组件添加
    add(fromData, toData, obj) {
      // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
      // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
      console.log(toData)
      this.toData = toData;
    },
    // 监听穿梭框组件移除
    remove(fromData, toData, obj) {
      // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
      // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表

      this.toData = toData;
    },

    handleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    OnConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.convertToList(this.toData);
          if (this.confirmDataList.length == 0) {
            this.$message({
              showClose: true,
              message: "请确认播放终端",
              type: "warning",
            });
            return;
          }
          this.SaveInfo();
        } else {
          return false;
        }
      });
    },
    onBack() {
      this.$emit("onBack", {});
    },
    nextStep() {
      this.$emit("nextStep", {});
    },
    search() {
      this.$emit("search", {});
    },
    preStep() {
      this.$emit("preStep", {});
    },
    convertToList(treeData) {
      treeData.map((item) => {
        if (item.type == "Device") {
          let { id, label, pid } = item;
          this.confirmDataList.push({ id, label, pid });
        }
        if (item.children.length > 0) {
          this.convertToList(item.children);
        }
      });
    },
    SaveInfo() {
      if (this.taskId === "") return;
      let TaskDevices = [];
      // console.log("this.TaskDeviceList")
      // console.log(this.TaskDeviceList)
      // if (this.TaskDeviceList.length > 0) {
      //   let delResult = [];
      //   let addResult = [];
      //   let mapA = {};
      //   let mapB = {};
      //   // 第一次循环得到id对应的map对象
      //   this.confirmDataList.forEach((element) => {
      //     mapA[element.id] = element;
      //   });
      //   this.TaskDeviceList.forEach((element) => {
      //     mapB[element.DeviceId] = element;
      //   });
      //   // 删除的广播节目在ProgramList中存在，在choiceDataList中不存在
      //   //新增的广播节目在ProgramList中不存在，在choiceDataList中存在
      //   this.TaskDeviceList.forEach((item) => {
      //     if (!mapA[item.DeviceId]) {
      //       item.ModifyTime = new Date();
      //       item.Modifier = new Date();
      //       item.Validity = 0;
      //       delResult.push(item);
      //     }
      //   });

      //   this.confirmDataList.forEach((item) => {
      //     let addItem = {};
      //     if (!mapB[item.id]) {
      //       addItem.TaskId = this.taskId;
      //       addItem.DeviceId = item.id;
      //       addItem.ModifyTime = new Date();
      //       addItem.Modifier = this.user.UserName;
      //       addItem.Validity = 1;
      //       addItem.CreateTime = new Date();
      //       addItem.Creater = this.user.UserName;
      //       addResult.push(addItem);
      //     }
      //   });
      //   TaskDevices = delResult.concat(addResult);
      // } else {
        // console.log("this.confirmDataList")
        // console.log(this.confirmDataList)
        this.confirmDataList.map((item) => {
          TaskDevices.push(item.id)
        });
      // }
      let params = {
        orderId:this.taskId,
        equipmentIds:TaskDevices
      }
      broadcastOrderBatchUpdate(params).then(res=>{
        console.log("播单绑定终端")
        console.log(res)
        if(res.code==200){
          this.$message({
            type: "success",
            message: "保存成功！"
          });
          this.search();
          this.onBack();
        }else{
          this.errmsg("保存失败！");
        }
      })
      // new MyApis.TaskDeviceApi()
      //   .UpdateItemList(TaskDevices)
      //   .then((r) => {
      //     r = r.data.Data;
      //     this.$message({
      //       type: "success",
      //       message: r ? "保存成功！" : "保存失败！",
      //     });
      //     this.loading = false;
      //     this.logInfo.ActionName = "终端配置添加";
      //     this.logInfo.LogMessage = r ? "终端配置添加成功" : "终端配置添加失败";
      //     this.logInfo.ModuleName = "广播系统";
      //     this.logInfo.PageName = "播单管理详情页面";
      //     this.addOperationLog();
      //     this.search();
      //   })
      //   .catch((e) => {
      //     this.loading = false;
      //     console.log(e);
      //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //   });
    },
  },
};
</script>

<style lang="scss">
.terminal-transfer {
  .wl-transfer .transfer-title {
    border-bottom: 1px solid #387ecc;
    background: transparent;
    font-size: 16px;
    color: white;
    font-weight: normal;
  }

  .wl-transfer .transfer-left,
  .wl-transfer .transfer-right {
    border: 1px solid #387ecc;
  }
}
</style>
